import { NumberCell } from '@ayocore/platform/client/components/EditableGrid';
import type { SupplierQuoteColumnKey, SupplierQuoteLike, SupplierQuotePatch } from './types';

export const quoteQtyColumn = NumberCell<
  SupplierQuoteLike,
  SupplierQuotePatch,
  SupplierQuoteColumnKey
>({
  key: 'qty',
  title: 'Кол-во',
  width: 85,
  fallback: 1,
  precision: 0,
  minValue: 0,
});
